module.exports = __webpack_public_path__ + "img/7.386f5a93.png";